import { addValuesToCookie, getCookieValues } from '@/utils/cookie-list-values';

export type FrequencyOption = 'always' | 'once-per-session' | 'once-per-browser';

interface FrequencyConfig {
  key: string;
  id?: string;
  frequency?: string;
}

export const normalizeFrequencyOption = (
  frequency: string | undefined,
  fallback?: FrequencyOption
): FrequencyOption | undefined => {
  const frequencyOption = frequency?.trim().toLowerCase() as FrequencyOption | undefined;

  if (
    frequencyOption === 'always' ||
    frequencyOption === 'once-per-browser' ||
    frequencyOption === 'once-per-session'
  ) {
    return frequencyOption;
  }

  return fallback;
};

export const shouldShow = (config: FrequencyConfig): boolean => {
  const { key, id, frequency } = config;
  const frequencyOption = normalizeFrequencyOption(frequency);

  if (!id || frequencyOption === 'always') {
    return true;
  }

  if (frequencyOption === 'once-per-browser') {
    const cookieKey = `${key}_CookiesPermanentDismissed`;
    return !getCookieValues(cookieKey).includes(id);
  }

  if (frequencyOption === 'once-per-session') {
    const sessionKey = `${key}_SessionDismissed`;
    const sessionDismissed = JSON.parse(sessionStorage.getItem(sessionKey) ?? '[]');
    return !sessionDismissed.includes(id);
  }

  return true;
};

export const markAsDismissed = (config: FrequencyConfig): void => {
  const { key, id, frequency } = config;
  const frequencyOption = normalizeFrequencyOption(frequency);

  if (!id) return;

  if (frequencyOption === 'once-per-session') {
    const sessionKey = `${key}_SessionDismissed`;
    const sessionDismissed = JSON.parse(sessionStorage.getItem(sessionKey) ?? '[]');
    sessionStorage.setItem(sessionKey, JSON.stringify([id, ...sessionDismissed]));
  }

  if (frequencyOption === 'once-per-browser') {
    const cookieKey = `${key}_CookiesPermanentDismissed`;
    addValuesToCookie(cookieKey, [id], 10, 365);
  }
};
